// ActionCard.jsx
import { useContext } from "react";
import "./Actions.css";
import { Context } from "../../../../context/Context";
import { APP_COLORS } from "../../../../utils/helpers";
import { ExpandableText } from "../../../ui";
import { actionTypeLabel, campaignTypeLabel, getActionDate } from "../../operationUtils";
import StatusBadge from "../../campaignActions/StatusBadge";
import ActionWorkflowButtons from "../../campaignActions/ActionWorkflowButtons";
import { getCampaignText } from "../../campaignActions/campaignActionsText";

export default function ActionCard({ action, storeId, showAppIndicator, onRefresh }) {
  const { lang } = useContext(Context);
  const campaignText = getCampaignText(lang);
  const tr = (ar, en) => (lang === "ar" ? ar : en);
  const expand = { expand: tr("اضغط لعرض النص كاملاً", "Click to show the full text"), collapse: tr("اضغط لطيّ النص", "Click to collapse the text") };

  const statusClassMap = {
    pending: "action-pending",
    inprogress: "action-inprogress",
    active: "action-active",
    completed: "action-completed",
    rejected: "action-rejected",
    canceled: "action-canceled",
  };
  const statusClass = statusClassMap[action.status] || "";

  // Who rejected it, and why (the reason is always recorded).
  let rejectedBy = null;
  let rejectionReason = null;
  if (action.status === "rejected") {
    const side = action.approvals?.client?.approved === false ? action.approvals.client : action.approvals?.manager?.approved === false ? action.approvals.manager : null;
    rejectedBy = side?.id?.name || null;
    rejectionReason = side?.reason || null;
  }

  const actionDate = getActionDate(action);

  return (
    <>
      <div className={`action-card ${statusClass}`}>
        <div className="action-card-header">
          <div className="operation-app-source">
            {showAppIndicator && action.appName && (
              <span
                className="operation-app-indicator"
                style={{
                  backgroundColor:
                    APP_COLORS[action.appName] || "var(--ui-border)",
                }}
                role="img"
                data-app-name={action.appName}
                title={action.appName}
                aria-label={action.appName}
              />
            )}
            <span className="action-type">
              {action.type === "campaigns" && action.campaignType
                ? campaignTypeLabel(action.campaignType, lang)
                : actionTypeLabel(action.type, lang)}
            </span>
          </div>
          <StatusBadge status={action.status} />
        </div>

        <div className="action-card-content">
          <ExpandableText text={action.content} labels={expand} />

          {action.type === "campaigns" &&
            (action.startDate || action.endDate) && (
              <div className="action-campaign-dates">
                {action.startDate && (
                  <span>
                    {campaignText.from}:{" "}
                    {new Date(action.startDate).toLocaleDateString()}
                  </span>
                )}
                {action.endDate && (
                  <span>
                    {campaignText.to}:{" "}
                    {new Date(action.endDate).toLocaleDateString()}
                  </span>
                )}
              </div>
            )}

          {action.approvals?.client?.onBehalfOfClient && (
            <ExpandableText
              className="action-origin"
              lines={1}
              threshold={60}
              labels={expand}
              text={[tr("اعتُمدت نيابةً عن العميل", "Approved on behalf of the client"), action.approvals.client.id?.name ? `— ${action.approvals.client.id.name}` : "", action.approvals.client.reason ? `(${action.approvals.client.reason})` : ""].filter(Boolean).join(" ")}
            />
          )}

          {action.origin === "alreadyActive" && (
            <span className="action-origin">{campaignText.alreadyActive}</span>
          )}
        </div>

        <div className="action-card-footer">
          <div className="action-controls">
            <ActionWorkflowButtons id={action._id} allowed={action.allowed} action={action} lang={lang} onDone={() => onRefresh?.()} />
            {action.status === "rejected" && rejectedBy && <span className="action-rejected-by">{rejectedBy}</span>}
          </div>

          <span className="action-date">
            {actionDate ? new Date(actionDate).toLocaleDateString() : "-"}
          </span>
        </div>

        {rejectionReason && (
          <ExpandableText className="action-error" lines={2} threshold={80} labels={expand} text={`${tr("سبب الرفض", "Rejection reason")}: ${rejectionReason}`} />
        )}
      </div>
    </>
  );
}